export const SET_ASSETS = "app/asset/SET_ASSETS";
export const GET_MODES = "app/asset/GET_MODES";
export const GET_ASSET_STATUS = "app/asset/GET_ASSET_STATUS";
export const GET_ASSETS_LOADING = "app/asset/GET_ASSETS_LOADING";
export const GET_INVENTORY = "app/asset/GET_INVENTORY";
export const GET_TANK_INFORMATION = "app/asset/GET_TANK_INFORMATION";
